module.exports = __webpack_public_path__ + "static/media/grid-item-c6.fe437ccf.png";